import axios, { AxiosInstance } from "axios";

import { clearToken, getToken, hasValidSession } from "./auth.utils.tsx";

// Esta pantalla habla con DOS servicios: identity firma los tokens y performance sirve el catálogo
// y los cálculos. El token es el mismo en los dos.
//
// Workflow ya no aparece. Antes hacía falta porque una hoja de cálculo necesitaba un proyecto para
// existir, y crear ese proyecto era de workflow; desde que una hoja nace suelta, esta pantalla no
// tiene nada que preguntarle. Los proyectos son de la otra UI.
const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL;
const PERFORMANCE_URL = process.env.REACT_APP_PERFORMANCE_URL;

const logoutAndRedirect = () => {
  clearToken();

  // Ya estamos en el login: no hace falta recargar, y así no se entra en bucle.
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
};

const createClient = (baseURL?: string): AxiosInstance => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  client.interceptors.request.use((config) => {
    const token = getToken();

    // Aquí y no solo en la respuesta: una sesión caducada se corta ANTES de salir a la red, así
    // que da igual lo que conteste el servidor —o si no contesta—. Es lo que hacía que un 401 sin
    // cabeceras de CORS pasara desapercibido: sin `error.response` no había redirección.
    //
    // Sólo cuando HAY token: sin él la petición es pública —login, registro, recuperación— y tiene
    // que salir. Cortarla también dejaba el login muerto, y como el rechazo es anterior a la red no
    // traía `error.response`: el usuario veía «Unexpected error (no-status)».
    if (token && !hasValidSession()) {
      logoutAndRedirect();
      return Promise.reject(new Error("Session expired"));
    }

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        logoutAndRedirect();
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export const identityApi = createClient(IDENTITY_URL);
export const performanceApi = createClient(PERFORMANCE_URL);

// El nombre viejo, para que auth, perfil y legal no cambien: todos son de identity.
export const api = identityApi;
